import { PUT } from './executer';
import apiServiceInstance from './apiService';

export interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
}

export interface UpdateProfileResponse {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  name: string;
}

class UsersService {
  /**
   * Update the current user's profile (firstName, lastName, phoneNumber)
   */
  async updateProfile(data: UpdateProfileRequest) {
    return await apiServiceInstance.client.execute<UpdateProfileResponse>(
      PUT,
      '/api/users/me',
      data
    );
  }
}

const usersServiceInstance = new UsersService();
export default usersServiceInstance;
